import { RIDE_STATUS_LABEL, type DocumentStatus, type PaymentStatus, type RequestStatus, type RideStatus } from '@tcrd/shared';
import { Badge, type Tone } from './Badge';

const rideTone: Record<RideStatus, Tone> = {
  REQUESTED: 'info',
  QUOTED: 'info',
  CONFIRMED: 'dark',
  DRIVER_ON_THE_WAY: 'warning',
  DRIVER_ARRIVED: 'warning',
  IN_PROGRESS: 'success',
  COMPLETED: 'neutral',
  CANCELLED: 'danger',
  EXPIRED: 'neutral',
};

export function RideStatusBadge({ status }: { status: RideStatus }) {
  return <Badge tone={rideTone[status]}>{RIDE_STATUS_LABEL[status]}</Badge>;
}

const requestLabel: Record<RequestStatus, [string, Tone]> = {
  REQUESTED: ['Pendiente de cotización', 'info'],
  INFO_REQUESTED: ['Información solicitada', 'warning'],
  QUOTED: ['Cotización recibida', 'warning'],
  CONFIRMED: ['Confirmada', 'success'],
  REJECTED: ['No disponible', 'danger'],
  CANCELLED: ['Cancelada', 'neutral'],
  EXPIRED: ['Expirada', 'neutral'],
};

export function RequestStatusBadge({ status }: { status: RequestStatus }) {
  const [label, tone] = requestLabel[status];
  return <Badge tone={tone}>{label}</Badge>;
}

const paymentLabel: Record<PaymentStatus, [string, Tone]> = {
  PENDING: ['Pago pendiente', 'warning'],
  REPORTED: ['Pago reportado', 'info'],
  PARTIALLY_PAID: ['Pago parcial', 'warning'],
  VERIFIED: ['Pago verificado', 'success'],
  REJECTED: ['Pago rechazado', 'danger'],
  VOID: ['Sin cobro (cancelado)', 'neutral'],
};

export function PaymentStatusBadge({ status }: { status: PaymentStatus }) {
  const [label, tone] = paymentLabel[status];
  return <Badge tone={tone}>{label}</Badge>;
}

const docLabel: Record<DocumentStatus, [string, Tone]> = {
  VALID: ['Vigente', 'success'],
  EXPIRING_SOON: ['Por vencer', 'warning'],
  EXPIRED: ['Vencido', 'danger'],
  PENDING_VERIFICATION: ['Pendiente de verificación', 'info'],
  REJECTED: ['Rechazado', 'danger'],
};

export function DocumentStatusBadge({ status }: { status: DocumentStatus }) {
  const [label, tone] = docLabel[status];
  return <Badge tone={tone}>{label}</Badge>;
}
